'use client';

import { Divider } from '@geberit/gdds';

// components
import CampusLayout from './CampusLayout';
import { ContactModule } from '../../components/Campus/Contact/ContactModule';

export function CampusMaintainence() {
  const styles = {
    downtimeContainer: {
      display: 'flex',
      gap: '1rem',
    },
    downtime: {
      display: 'flex',
      margin: '10px 0',
      padding: '0.5rem 1rem',
      border: '1px solid #ccc',
      borderRadius: '3px',
      backgroundColor: '#f9f9f9',
    },
  };

  return (
    <CampusLayout isLandingPage>
      <br />
      <h1>
        Campus is currently in <br />
        <b>Maintenance Mode</b>
      </h1>
      <h3>Planned Downtime:</h3>
      <div style={styles.downtimeContainer}>
        <div style={styles.downtime}>
          <p>
            Start: <br />
            <b>Tuesday, 05 August at 6:00 CEST</b>
          </p>
        </div>
        <div style={styles.downtime}>
          <p>
            End:
            <br /> <b>Wednesday, 06 August at 18:00 CEST</b>
          </p>
        </div>
      </div>

      <br />

      <p>
        Our team is working behind the scenes to update the platform. <br /> We apologize for the
        inconvenience and appreciate your understanding during this time.
      </p>
      <br />
      <Divider />
      <br />
      <ContactModule />
    </CampusLayout>
  );
}
